import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: '' }


export const checkOtpAction = createAsyncThunk(
    'check-otp',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/auth/check/otp`, {email: data?.email, otp: data?.password})
            //const res = await axios.post(`/support-server/api/register-admin`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const checkOtpSlice = createSlice({
    name: 'check-otp',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(checkOtpAction.pending, (state) => {

                state.loading = true
            })
            builder.addCase(checkOtpAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(checkOtpAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const checkOtpReducer = checkOtpSlice.reducer